<template>
    <div>
        
        <h2 v-if="!hideTitle" class="text-2xl mb-3">{{ jobOffer.title }}</h2>

        <div v-if="jobOffer.origin === 'site'" class="bg-orange-100 border border-orange-600 text-orange-800 px-5 py-2 rounded">Let op: deze vacature is handmatig ingevoerd door {{ jobOffer.company.name }}.</div>

        <div class="sticky bg-white px-0 py-3 mt-0" style="top: -20px;">
            <div class="bg-gray-100 p-3 flex flex-wrap items-center justify-left rounded">


                <div class="mr-5"><i class="fal fa-building mr-1"></i>{{ jobOffer.company ? jobOffer.company.name : "onbekend" }}</div>

                <div class="mr-5">
                    <i class="fal fa-map-marker-alt mr-1"></i>
                    {{ jobOffer.place ? jobOffer.place.name : "onbekend" }}
                    <i v-if="jobOffer.place" class="ml-1 fad"></i>

                    <!-- {{ jobOffer.region ? jobOffer.region.name : "onbekend" }}
                    <i class="ml-1 fad" :class="jobOffer.region.id ? 'fa-check' : 'fa-question'"></i> -->
                </div>

                <div class="mr-5"><i class="fal fa-clock mr-1"></i>{{ jobOffer.hours || "onbekend" }}</div>

                <div class="mr-5 flex items-center">
                    <i class="fal mr-1" :class="this.loading === 'saveSalary' ? 'fa-spinner fa-spin' : 'fa-hand-holding-usd'"></i>
                    <input v-if="editable" type="text" ref="salaryInput" v-model="form.salary" class="px-2 py-1 rounded w-40 border border-gray-300" @change="updateSalary" />
                    <div v-else>{{ form.salary || "onbekend" }}</div>
                </div>

                <div class="flex-grow text-right">
                    <div v-if="jobOffer.reviewed_at && !jobOffer.published" class="text-red-500">
                        <i class="fad fa-industry-alt mr-1"></i>
                    </div>
                    <div v-if="jobOffer.reviewed_at && jobOffer.published" class="text-green-500">
                        <i class="fad fa-leaf mr-1"></i>
                    </div>
                    <div v-if="!jobOffer.reviewed_at" class="text-gray-500">
                        <i class="fad fa-question mr-1"></i>
                    </div>
                </div>
            </div>
            
            <div class="mt-5">
                <job-template-select 
                    :options="jobtemplates" 
                    :selected="jobOffer.jobtemplate"
                    :loading="loading"
                    @select="selectJobTemplate"
                ></job-template-select>
            </div>
            <tag-select 
                :tags="tags" 
                :tags-selected="jobOffer.tags"
                :loading="loading"
                @tag-added="addTag"
                @tag-removed="removeTag"
            ></tag-select>

        </div>
        <div class="mt-3 styled-content" v-html="jobOffer.description" tabindex="0" ref="joboffercontent"></div>
        <!-- <button
            @click.prevent="save()"
            class="mt-5 text-white bg-teal-700 px-5 py-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800"
        >
            <i class="fal mr-1" :class="loading == 'save' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Save
        </button> -->

        <!-- <wysiwyg :value="description" v-model="description" @input="save()"></wysiwyg> -->
    </div>
</template>

<script>
import _ from "lodash";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import TagSelect from "@/admin/Components/TagSelect";
import JobTemplateSelect from "@/admin/Components/JobTemplateSelect";
import wysiwyg from "@/admin/Shared/WYSIWYG";
import hotkeys from "hotkeys-js";

export default {
    mixins: [Helpers],

    components: { TagSelect, wysiwyg, JobTemplateSelect },

    props: {
        jobOffer: Object,
        hideTitle: Boolean,
        tags: Array,
        jobtemplates: Array,
        editable: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            tag: "",
            description: this.jobOffer.description,
            form: {
                salary: this.jobOffer.salary
            }
        };
    },
    watch: {
        jobOffer: function (newJobOffer) {
            this.form.salary = newJobOffer.salary
        }
    },
    methods: {
        updateSalary() {
            this.loading = "saveSalary";

            const url = this.route("admin.joboffers.update", this.jobOffer.id);
            const data = { salary: this.form.salary };
            const options = { preserveState: true, preserveScroll: true };

            this.$inertia.patch(url, data, options).then(() => {
                this.loading = "";
            });
        },

        addTag(tag) {
            this.loading = "addTag";

            const url = this.route("admin.joboffers.tags.store", this.jobOffer.id);
            const data = { tagId: tag.id };

            this.$inertia.post(url, data, { preserveState: true, preserveScroll: true }).then(() => {
                this.tag = "";
                this.loading = "";
            });
        },

        removeTag(tag) {
            this.loading = "removeTag";

            const url = this.route("admin.joboffers.tags.destroy", this.jobOffer.id) + "?tagId=" + tag.id;
            const options = { preserveState: true, preserveScroll: true };

            this.$inertia.delete(url, options).then(() => {
                this.loading = "";
            });
        },

        selectJobTemplate(jobtemplate) {
            this.loading = "applyTemplate";

            const url = this.route("admin.joboffers.jobtemplate.create", this.jobOffer.id);
            const data = { jobtemplate: jobtemplate.id };

            this.$inertia.post(url, data, { preserveState: true, preserveScroll: true }).then(() => {
                this.loading = "";
            });
        },

        save: _.debounce(function() {
            this.loading = "save";

            const data = { description: this.description };
            const options = { preserveState: true, preserveScroll: true };

            this.$inertia.patch(this.route("admin.joboffers.update", this.jobOffer.id), data, options).then(() => (this.loading = ""));
        }, 500)
    },

    mounted() {
        // if (this.editable) {
            // hotkeys.filter = function(event){
            //     return true;
            // }
            const salaryInput = this.$refs.salaryInput;
                hotkeys("cmd+4", function(event, handler) {
                    event.preventDefault();
                    salaryInput.focus();
                    return false
                });
        // }
        document.getElementById("layoutcontent").focus();
    }
};
</script>